import { all, takeEvery } from 'redux-saga/effects';
import { actionTypes } from './actions';
import { saveClientContract } from './workers/saveClientContract';
import { deleteClientContract } from './workers/deleteClientContract';

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.SAVE_CLIENT_CONTRACT, saveClientContract)]);
  yield all([takeEvery(actionTypes.DELETE_CLIENT_CONTRACT, deleteClientContract)]);
}
